<template>
  <div>
    <vs-table search stripe border description :sst="true" :data="table.data" :max-items="table.length"
      :total="table.total" @search="handleSearch" @change-page="handleChangePage" @sort="handleSort">
      <template slot="header">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div class="
              p-3
              border border-solid
              d-theme-border-grey-light
              rounded-full
              d-theme-dark-bg
              cursor-pointer
              flex
              items-center
              justify-between
              font-medium
            ">
            <span class="mr-2">{{ this.table.start }} - {{ this.table.end }} of
              {{ this.table.total }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item v-for="item in table.limits" :key="item" @click="handleChangelength(item)">
              <span>{{ item }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </template>
      <template slot="thead">
        <!-- <vs-th></vs-th> -->
        <vs-th v-for="(head, index) in this.table.heads" :key="index">{{ head.title }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <div v-if="tr.sales_orders">
              <div :data="td" :key="idx" v-for="(td, idx) in tr.sales_orders">
                {{ td.PoReferenceCode }}
              </div>
            </div>
          </vs-td>
          <vs-td>
            <div v-if="tr.sales_orders">
              <div :data="td" :key="idx" v-for="(td, idx) in tr.sales_orders">
                {{ td.Code }}
              </div>
            </div>
          </vs-td>
          <vs-td>({{ tr.terr_code }}) {{ tr.terr_name }}</vs-td>
          <vs-td>{{ tr.file_name }}.{{ tr.file_type }}</vs-td>
          <vs-td>{{ tr.status }}</vs-td>
          <vs-td>
            <p>Start process at : {{ dateFormatWithTime(tr.created_at) }}</p>
            <p>End process at : {{ dateFormatWithTimeAdd7(tr.end_process_at) }}</p>
          </vs-td>
          <vs-td>{{ tr.remark }}</vs-td>
          <vs-td>
            <vs-button color="grey" title="Download" icon-pack="feather" icon="icon-download"
              @click="handleDownload(tr.file_path, tr.id)"> Download</vs-button>
          </vs-td>
          <vs-td>{{ tr.user_name }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-pagination style="padding-top: 5px" :total="table.totalPage" v-model="setPage" />
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
import { numberFormat } from "@/utils/helper";
export default {
  props: {
    territoryIDs: {
      type: String,
    },
    status: {
      type: String,
    },
    invDateFrom: {
      type: Date,
    },
    invDateTo: {
      type: Date,
    },
    soNumberNd6: {
      type: String,
    },
    invNumber: {
      type: String,
    },
    draw: {
      type: Number,
    },
  },
  data() {
    return {
      deleteId: null,
      // FIX: track in-flight request so we can cancel it before starting a new one
      cancelSource: null,
      table: this.tableDefaultState()
    };
  },
  // FIX: cancel any pending request when the component is destroyed
  beforeDestroy() {
    if (this.cancelSource) this.cancelSource.cancel();
  },
  methods: {
    numberFormat,
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
        heads: [
          {
            field: "so_code_nd6",
            title: "ND6 Codes"
          },
          {
            field: "so_code",
            title: "Sales Order Codes"
          },
          {
            field: "territory",
            title: "Territory"
          },
          {
            field: "filename",
            title: "File Name"
          },
          {
            field: "status",
            title: "Status"
          },
          {
            field: "process",
            title: "Process"
          },
          {
            field: "remark",
            title: "Remark"
          },
          {
            field: "download",
            title: "Download"
          },
          {
            field: "download_by",
            title: "Download By"
          }
        ]
      };
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    handleClose() {
      this.getData();
      this.$emit("close");
    },
    getData() {
      // FIX: cancel the previous in-flight request before firing a new one.
      // This prevents stale responses overwriting newer data and stops
      // overlapping requests from accumulating in the Network tab.
      if (this.cancelSource) {
        this.cancelSource.cancel("superseded");
      }
      this.cancelSource = axios.CancelToken.source();

      this.$vs.loading();
      this.$http
        .get("/api/v1/billing-cmi/export-data", {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
          },
          cancelToken: this.cancelSource.token, // ← attach token
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.status === "success") {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.data = resp.data.records;
            this.setStartEnd();
          }
        })
        .catch((err) => {
          // FIX: silently ignore cancellations; only surface real errors
          if (axios.isCancel(err)) return;
          this.$vs.loading.close();
        })
        .finally(() => {
          this.cancelSource = null;
        });
    },
    handleDownload(filePath, id) {
      try {
        this.$http.get(`/api/v1/billing-cmi/download/${id}`)
          .then(resp => {
            if (resp.code == 200) {
              this.downloadFileAwsS3(filePath)
              this.$vs.notify({
                color: "success",
                title: "Success",
                text: "File downloaded successfully",
                position: "top-right",
                iconPack: "feather",
                icon: "icon-check-circle"
              });
              this.getData()
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Failed",
                text: resp.message,
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle",
                time: 10000,
              });
            }
          })
      } catch (error) {
        console.error("Error downloading file:", error.message);
        this.$vs.notify({
          color: "danger",
          title: "Failed",
          text: error.message,
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
          time: 10000,
        });
      }
    },
    formatDownloadBy(value) {
      if (!value || typeof value !== 'string') {
        return ""; // Return an empty string or handle null/invalid input as needed
      }
      return value
        .split(";")                      // Split the string into an array
        .filter((name) => name.trim())   // Remove empty values and trim whitespace
        .filter((name, index, self) => self.indexOf(name) === index) // Remove duplicates
        .reverse()                       // Reverse the order
        .join("\n");                     // Join with newline characters
    },
    dateFormatWithTime(date) {
      if (date) {
        if (String(date).includes("-")) {
          return moment.utc(String(date))
            .format("YYYY-MM-DD HH:mm:ss");
        } else if (String(date).includes("/")) {
          const inputDate = String(date);
          const parts = inputDate.split("/");
          if (parts.length === 3) {
            return moment
              .utc(`${parts[2]}-${parts[1]}-${parts[0]}`)
              .format("YYYY-MM-DD HH:mm:ss");
          } else {
            return "";
          }
        } else {
          const inputDate = String(date);
          if (inputDate.length >= 8) {
            const day = inputDate.substr(0, 2);
            const month = inputDate.substr(2, 2);
            const year = inputDate.substr(4, 4);

            const formattedDate = `${year}-${month}-${day}`;
            return moment
              .utc(formattedDate)
              .format("YYYY-MM-DD HH:mm:ss");
          } else {
            return "";
          }
        }
      }
    },
    dateFormatWithTimeAdd7(date) {
      if (date) {
        if (String(date).includes("-")) {
          return moment.utc(String(date))
            .add(7, 'hours')
            .format("YYYY-MM-DD HH:mm:ss");
        } else if (String(date).includes("/")) {
          const inputDate = String(date);
          const parts = inputDate.split("/");
          if (parts.length === 3) {
            return moment
              .utc(`${parts[2]}-${parts[1]}-${parts[0]}`)
              .add(7, 'hours')
              .format("YYYY-MM-DD HH:mm:ss");
          } else {
            return "";
          }
        } else {
          const inputDate = String(date);
          if (inputDate.length >= 8) {
            const day = inputDate.substr(0, 2);
            const month = inputDate.substr(2, 2);
            const year = inputDate.substr(4, 4);

            const formattedDate = `${year}-${month}-${day}`;
            return moment
              .utc(formattedDate)
              .add(7, 'hours')
              .format("YYYY-MM-DD HH:mm:ss");
          } else {
            return "";
          }
        }
      }
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;

      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;

      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      if (
        this.table.totalSearch < this.table.total &&
        this.table.search != ""
      ) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    dateFormat(val) {
      // return moment(val).local();
      return moment(val)
        .add(-7, "h")
        .utc()
        .local();
    }
  },
  watch: {
    draw(val) {
      if (val > 0) {
        this.getData();
      }
    }
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      }
    }
  }
};
</script>
